module.exports = __webpack_public_path__ + "img/con5.f9a40e1b.png";